import { Tooltip as MTooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';

import type { TooltipProps as MTooltipProps } from '@mui/material';

const TPTooltip = styled(({ className, ...props }: MTooltipProps) => {
  const { placement, ...rest } = props;
  return (
    <MTooltip
      {...rest}
      classes={{ popper: className }}
      placement={placement ? placement : 'bottom'}
    />
  );
})(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    boxSizing: 'border-box',
    borderRadius: '0 0 10px 10px',
    display: 'flex',
    alignItems: 'center',
    padding: '1em 1em 0.8em 1em',
    maxWidth: '85em !important',
    marginTop: '-0.4em !important',
    zIndex: '0 !important',
    color: FORTA_WHITE,
    backgroundColor: FORTA_BLUE.light1,
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
}));

export default TPTooltip;
